import apiClient from './api.ts';
import {ClassSchema} from "@/types/class_schema.ts";

export default {
    async getAllClasses(isActive: boolean, page: number = 1, limit: number = 20, sort: string = 'id', order: 'asc' | 'desc' = 'asc', academicYearId?: number) {
        const params = new URLSearchParams({
            is_active: isActive.toString(),
            page: page.toString(),
            limit: limit.toString(),
            sort,
            order
        });
        if (academicYearId) {
            params.set('academic_year_id', academicYearId.toString());
        }
        return await apiClient.get(`classes?${params}`);
    },
    async createClass(clas: ClassSchema) {
        return await apiClient.post(`classes`, clas);
    },
    async updateClass(classId: number, clas: ClassSchema) {
        return await apiClient.put(`classes/${classId}`, clas);
    },
    async deleteClass(classId: number) {
        return await apiClient.delete(`classes/${classId}`);
    },
    async archiveClass(classId: number) {
        return await apiClient.put(`classes/${classId}/archive`);
    },
    async unarchiveClass(classId: number) {
        return await apiClient.put(`classes/${classId}/unarchive`);
    },
    async getClassByCourseId(schoolId: number, courseId: number) {
        return await apiClient.get(`classes/course/${courseId}/school/${schoolId}`);
    },
    async getClassByGradeId(schoolId: number, gradeId: number, page: number = 1, limit: number = 20, sort: string = 'id', order: 'asc' | 'desc' = 'asc', academicYearId?: number) {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
            sort,
            order
        });
        if (academicYearId) {
            params.set('academic_year_id', academicYearId.toString());
        }
        return await apiClient.get(`classes/grade/${gradeId}/school/${schoolId}?${params}`);
    },
    
    // Batch create grades and classes together for academic year setup
    async batchCreateGradesAndClasses(
        yearId: number, 
        data: {
            grades: Array<{ name: string; level: number; description?: string }>;
            classes: Array<{ grade_id?: number; new_grade_index?: number; name: string; capacity?: number }>;
            reuse_existing?: boolean;
        }
    ) {
        return await apiClient.post(`academic-years/${yearId}/classes/batch`, data);
    }
};
